export default __webpack_public_path__ + "static/media/calendar-attendance.f8cf8a88.svg";